export default {
      id: "icon-smiley-losange-usage",
      viewBox: "0 0 151.4 106.9",
      url: __webpack_public_path__ + "icons.svg#icon-smiley-losange",
      toString: function () {
        return this.url;
      }
    }